import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  href = '#cta',
  className = '',
  onClick
}: ButtonProps) {
  const isExternal = href.startsWith('http');
  const isAnchor = href.startsWith('#');
  const handleClick = (e: React.MouseEvent) => {
    if (isAnchor) {
      e.preventDefault();
      const target = document.querySelector(href);
      target?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.();
  };
  return <motion.a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center 
        bg-gold hover:bg-gold-dark text-black 
        font-sans font-bold text-base md:text-xl
        px-6 py-3.5 md:px-8 md:py-4 rounded-full 
        shadow-lg shadow-gold/20 hover:shadow-xl hover:shadow-gold/30
        transition-all duration-300
        ${className}
      `} data-id="element-284">
      {children}
    </motion.a>;
}